module.exports = __webpack_public_path__ + "img/DW365-320.21973a70.jpg";